import React from 'react';
import CrossRoad from "../UI/Crossroad";

const CrossRoad_5KBlue_5EBlack = () => <CrossRoad coords="1688.000000, 550.000000"/>;
export default CrossRoad_5KBlue_5EBlack;
